import React, { useRef, useState } from "react";

import ReactToPrint from "react-to-print";

import { Flex, Link, Spinner, Text, Box } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";
import AvisosService from "../../../main/services/AvisosService";
import { ComponentToPrintCriancaAvisos } from "../ComponentToPrintCriancaAvisos";
import { MdOutlineLocalPrintshop } from "react-icons/md";
import { useAuthProvider } from "../../../Context/AuthProvider";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";

export const PrintButtonAvisos = ({
  idTipoAviso,
  isPrinting,
  printingId,
  setIsPrinting,
  setPrintingId,
}) => {
  const componentToPrintRef = useRef(null);
  const [dataPendencias, setDataPendencias] = useState([]);
  const [descricaoTipoAviso, setDescricaoTipoAviso] = useState([]);
  const [columnsAvisos, setColumnsAvisos] = useState([]);
  const { roleKeycloack, user } = useAuthProvider();

  const beforeGetContent = async () => {
    setIsPrinting(true);
    setPrintingId(idTipoAviso);
    try {
      const TipoAviso = {
        1: "ACOLHIDOS_ULTIMOS_7_DIAS",
        2: "ACOLHIDOS_15_DIAS_SEM_REGISTRO_CIVIL",
        3: "ACOLHIDOS_2_MESES_SEM_PROCESSO_JUDICIAL",
        4: "ACOLHIDOS_MAIS_18_MESES",
        5: "ACOLHIDOS_SEM_VISITA_2_MESES",
        6: "ACOLHIDOS_REQUISITOS_ADOCAO",
        7: "ACOLHIDOS_FORA_AREA_ATUACAO",
      };

      const tipoAviso = TipoAviso[idTipoAviso];

      const res = await AvisosService.getTiposAvisos(tipoAviso);

      if (res?.data[0]?.criancas) {
        setColumnsAvisos([
          {
            Header: "Nome/Nome Social",
            accessor: "nomeCrianca",
            Cell: (props) => {
              const id = props?.row?.original?.idCrianca;
              let name = props?.row?.original?.nomeCrianca;
              let ultimaMovimentacao = props?.row?.original?.movimentacoes[0];

              let temRiscoVida = false;
              let ultimaMovimentacaoRisco;

              if (ultimaMovimentacao?.idMovimento !== 2) {
                ultimaMovimentacaoRisco =
                  props?.row?.original?.movimentacoes[0];
              }

              if (props?.row?.original?.nomeSocial) {
                name = name + " / " + props.row.original.nomeSocial;
              }

              if (
                props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
                props?.row?.original?.movimentacoes[0]?.idMovimento === 6
              ) {
                const movimentacoes = props?.row?.original?.movimentacoes || [];

                for (const mov of movimentacoes) {
                  if (mov?.idMovimento === 3 || !mov?.idMovimento) {
                    temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
                    break;
                  }
                }
              }

              return (roleKeycloack &&
                roleKeycloack.includes(criancaFunc.visualizar)) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM
                ) ? (
                (ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao === "N" ||
                  !ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao) &&
                !temRiscoVida ? (
                  <Link
                    wordBreak={"break-all"}
                    title={name}
                    as={ReactLink}
                    to={"/crianca/" + id}
                  >
                    <Flex alignItems="center" gap={2}>
                      {ultimaMovimentacao?.descricaoTipoSituacao ===
                        "Acolhido" && ultimaMovimentacao?.idMovimento === 2 ? (
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                      ) : ultimaMovimentacao?.descricaoTipoSituacao ===
                          "Acolhido" ||
                        ultimaMovimentacao?.descricaoTipoSituacao ===
                          "Desligado" ? (
                        <Box w="3" h="3" borderRadius="full" />
                      ) : (
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                      )}
                      <Text
                        display="flex"
                        h={"40px"}
                        alignItems={"center"}
                        minWidth="250px"
                      >
                        {name}
                      </Text>
                    </Flex>
                  </Link>
                ) : (
                  <Link wordBreak={"break-all"} title={name}>
                    <Flex alignItems="center" gap={2}>
                      {ultimaMovimentacao?.descricaoTipoSituacao ===
                        "Acolhido" && ultimaMovimentacao?.idMovimento === 2 ? (
                        <Box
                          w="4"
                          h="4"
                          bg="#169499"
                          borderRadius="full"
                          border="1px"
                          color="#169499"
                        />
                      ) : ultimaMovimentacao?.descricaoTipoSituacao ===
                          "Acolhido" ||
                        ultimaMovimentacao?.descricaoTipoSituacao ===
                          "Desligado" ? (
                        <Box w="3" h="3" borderRadius="full" />
                      ) : (
                        <Box
                          w="4"
                          h="4"
                          bg="red"
                          borderRadius="full"
                          border="1px"
                          color="red"
                        />
                      )}
                      <Text
                        display="flex"
                        h={"40px"}
                        alignItems={"center"}
                        minWidth="250px"
                      >
                        {name}
                      </Text>
                    </Flex>
                  </Link>
                )
              ) : ultimaMovimentacao?.riscoVidaMotivoSituacao === "N" ||
                !ultimaMovimentacao?.riscoVidaMotivoSituacao ? (
                <Flex alignItems="center" gap={2}>
                  {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                    <Box w="3" h="3" borderRadius="full" />
                  ) : (
                    <Box
                      w="3"
                      h="3"
                      bg="red"
                      borderRadius="full"
                      F
                      border="1px"
                      color="red"
                    />
                  )}
                  <Text
                    display="flex"
                    h={"40px"}
                    alignItems={"center"}
                    minWidth="250px"
                  >
                    {name}
                  </Text>
                </Flex>
              ) : (
                <Flex alignItems="center" gap={2}>
                  {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                    <Box w="3" h="3" borderRadius="full" />
                  ) : (
                    <Box
                      w="3"
                      h="3"
                      bg="red"
                      borderRadius="full"
                      border="1px"
                      color="red"
                    />
                  )}
                  <Text
                    display="flex"
                    h={"40px"}
                    alignItems={"center"}
                    minWidth="250px"
                  >
                    {name}
                  </Text>
                </Flex>
              );
            },
          },
          {
            Header: "Idade",
            accessor: "idade",
            Cell: (props) => {
              return <Text>{props.value ?? ""}</Text>;
            },
          },
          {
            Header: "Filiação",
            accessor: "pais",
            sortType: (rowA, rowB, id, desc) => {
              const filiacoesA = rowA?.original?.filiacoes?.length
                ? rowA.original.filiacoes
                    .map((filiacao) => filiacao?.filiacao?.nome || "")
                    .reduce((prev, filiacao) => prev + filiacao, "")
                : "";
              const filiacoesB = rowB?.original?.filiacoes?.length
                ? rowB.original.filiacoes
                    .map((filiacao) => filiacao?.filiacao?.nome || "")
                    .reduce((prev, filiacao) => prev + filiacao, "")
                : "";
              return filiacoesA.localeCompare(filiacoesB, "pt-BR");
            },
            Cell: (props) => {
              return props?.value
                .sort((a, b) =>
                  a.descricaoTipoRelacionamento.localeCompare(
                    b.descricaoTipoRelacionamento
                  )
                )
                .map((filiacao, index) => {
                  return (
                    <React.Fragment key={index}>
                      <span style={{ wordBreak: "break-word" }}>
                        {filiacao?.nome}{" "}
                        <Text as="span" textTransform="capitalize">
                          ({filiacao?.descricaoTipoRelacionamento.toLowerCase()}
                          )
                        </Text>
                      </span>
                      {props.value.length - 1 !== index && <br />}
                    </React.Fragment>
                  );
                });
            },
          },
          {
            Header: "Serviço de Acolhimento",
            accessor: "servicoAcolhimento",
            sortType: (rowA, rowB, id, desc) => {
              const nomeServicoA = rowA?.original?.servicoAcolhimento
                ? rowA.original.servicoAcolhimento.nomeFantasia
                : "";
              const nomeServicoB = rowB?.original?.servicoAcolhimento
                ? rowB.original.servicoAcolhimento.nomeFantasia
                : "";
              return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
            },
            Cell: (props) => {
              const permissaoServico =
                roleKeycloack.includes(criancaFunc.visualizarTudo) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarPartePPCAAM
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteMP
                ) ||
                roleKeycloack.includes(
                  servicoAcolhimentoFunc.visualizarParteTJ
                ) ||
                ((roleKeycloack.includes(
                  criancaFunc.visualizarTudoAcolhimento
                ) ||
                  roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
                  user?.orgaoExterno?.includes(
                    props?.row?.original?.servicoAcolhimento?.idPessoaJuridica
                  ));
              let temRiscoVida = false;

              if (
                props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
                props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
                props?.row?.original?.movimentacoes[0]?.idMovimento === 6
              ) {
                const movimentacoes = props?.row?.original?.movimentacoes || [];

                for (const mov of movimentacoes) {
                  if (mov?.idMovimento === 3 || !mov?.idMovimento) {
                    temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
                    break;
                  }
                }
              }

              if (
                (props?.row?.original?.movimentacoes[0]
                  ?.riscoVidaMotivoSituacao === "S" &&
                  !permissaoServico) ||
                (!permissaoServico &&
                  (props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
                    props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
                    props?.row?.original?.movimentacoes[0]?.idMovimento ===
                      6) &&
                  temRiscoVida)
              ) {
                return <span></span>;
              } else {
                const idServico = props?.row?.original?.servicoAcolhimento?.id;
                if (!idServico) {
                  return <span></span>;
                } else {
                  return (
                    <>
                      {roleKeycloack &&
                      roleKeycloack.includes(
                        servicoAcolhimentoFunc.visualizar
                      ) ? (
                        <Link
                          wordBreak={"break-word"}
                          title={
                            props.value
                              ? props.value.nomeFantasia +
                                `${
                                  props?.value?.suspenso === "S"
                                    ? " (Suspenso)"
                                    : ""
                                }`
                              : ""
                          }
                          as={ReactLink}
                          to={"/servico-acolhimento/" + idServico}
                        >
                          <Text>
                            {" "}
                            {props.value
                              ? props.value.nomeFantasia +
                                `${
                                  props?.value?.suspenso === "S"
                                    ? " (Suspenso)"
                                    : ""
                                }`
                              : ""}
                          </Text>
                        </Link>
                      ) : (
                        <Text>
                          {props.value
                            ? props.value.nomeFantasia +
                              `${
                                props?.value?.suspenso === "S"
                                  ? " (Suspenso)"
                                  : ""
                              }`
                            : ""}
                        </Text>
                      )}
                    </>
                  );
                }
              }
            },
          },
        ]);
      }

      setDataPendencias(res?.data[0]?.criancas);
      setDescricaoTipoAviso(res?.data[0]);
    } catch (erro) {
      console.log("Erro ao acessar os dados de impressao");
      console.log(erro);
    } finally {
      setIsPrinting(false);
      setPrintingId(null);
    }
  };

  const customPageStyle = `
    @page { 
      size: auto;  
      margin-top: 0mm; 
      margin-bottom: 10mm;
      margin-right: 0mm;
      margin-left: 0mm;
    } 
    @media print { 
      body { 
        -webkit-print-color-adjust: exact; 
      } 
    }
`;

  return (
    <>
      <ReactToPrint
        onBeforeGetContent={beforeGetContent}
        onAfterPrint={() => {
          setIsPrinting(false);
          setPrintingId(null);
        }}
        pageStyle={customPageStyle}
        documentTitle={`MCA - Avisos`}
        trigger={() =>
          isPrinting && printingId === idTipoAviso ? (
            <Spinner size="sm" />
          ) : (
            <MdOutlineLocalPrintshop size={21} color="#5D8792CC" />
          )
        }
        content={() => componentToPrintRef.current}
      />
      <div style={{ display: "none" }}>
        <ComponentToPrintCriancaAvisos
          ref={componentToPrintRef}
          dataPendencias={dataPendencias ? dataPendencias : null}
          columnsAvisos={columnsAvisos}
          tipoAviso={idTipoAviso}
          descricaoTipoAviso={descricaoTipoAviso}
        />
      </div>
    </>
  );
};
